import React from 'react';
import styled, { css } from 'styled-components';
import defaultAvatar from 'images/avatar.svg';

type Props = {
  alt: string;
  round?: boolean;
  size?: number;
  src?: string;
  title?: string;
};

export const StyledAvatar = styled('img').withConfig({
  shouldForwardProp: (prop) => !['round'].includes(prop),
})<Props>`
  height: 4.5rem;
  width: 4.5rem;
  border-radius: 0;
  border: 2px solid #EEEEEE;

  ${(props) =>
    props.round &&
    css`
      border-radius: 50%;
    `}

  ${(props) =>
    props.size &&
    css`
      width: ${props.size}rem;
      height: ${props.size}rem;
    `}

  &:hover {
    border: 2px solid #FFFFFF;
    outline 2px solid rgb(0, 113, 188);
    transition: all 0.2s ease-in-out;
  }
`;

export function Avatar({ alt, round, size, src, title }: Props) {
  return (
    <StyledAvatar
      alt={alt}
      title={title || alt}
      round={round}
      size={size}
      src={src || defaultAvatar}
    />
  );
}
